module.exports = __webpack_public_path__ + "img/img7.ad54cfac.png";